var _defs, _circle, _circle2, _path, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFamilie = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #6e9530;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.7,
    cy: 19.4,
    r: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75.1,
    cy: 46.2,
    r: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149,48.6c-1.2,1.2-3.2,1.2-4.4,0l-14.2-12,6.2,35h-4v12.6c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4v-12.6h-4.6v12.6c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4v-12.6h-4.2l6.5-35-14.2,12c-.3.3-.7.5-1,.7.3,1.2-.2,2.5-1.4,3.1l-13,7.5c-.3.2-.7.3-1,.3v25.6c0,1.6-1.3,2.9-2.9,2.9h0c-1.6,0-2.9-1.3-2.9-2.9v-13.2h-2.3v13.2c0,1.6-1.3,2.9-2.9,2.9h0c-1.6,0-2.9-1.3-2.9-2.9v-25.6c-.2,0-.4-.1-.6-.2l-13-7.5c-1.1-.6-1.6-1.8-1.4-3-.5-.1-1-.4-1.4-.8l-12-12v26h0v21.6c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4v-21.6h-4.6v21.6c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4v-47.6l-12,12c-1.2,1.2-3.3,1.2-4.5,0-1.1-1.2-1.1-3.2.1-4.4l13.2-13.2c2-2,4.6-3.1,7.4-3.1h13.8c2.8,0,5.4,1.1,7.4,3.1l13.2,13.2c.8.8,1.1,2,.8,3,.2,0,.3.1.5.2l10.8,6.2h13.7l11-6.2s0,0,.1,0c-.3-1.1,0-2.4.8-3.2l15.4-13.2c2-2,4.6-3.1,7.4-3.1h9.3c2.8,0,5.4,1.1,7.4,3.1l15.4,13.2c1.2,1.2,1.2,3.2,0,4.4h0Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 121.4,
    cy: 19.4,
    r: 7
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFamilie);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/familie.8112358fa4442899a7fdf3e01d73cc86.svg";